import { createStore as createVuexStore } from 'vuex'
import { Documents, IDocumentsState } from '@/store/modules/Documents.module'
import { IUsersState, Users } from '@/store/modules/Users.module'
import { IMessagesState, Messages } from '@/store/modules/Messages.module'
import { Account, IAccountState } from '@/store/modules/Account.module'
import { INotificationsState, Notifications } from '@/store/modules/Notifications.module'
import { Downloads, IDownloadsState } from '@/store/modules/Downloads.module'
import { ICompaniesState, Companies } from '@/store/modules/Companies.module'
import type { AppStore } from '@/store/types'

export interface IState {
  Messages: IMessagesState,
  Users: IUsersState,
  Account: IAccountState,
  Notifications: INotificationsState,
  Documents: IDocumentsState,
  Downloads: IDownloadsState,
  Companies: ICompaniesState
}

export function createStore(): AppStore {
  return createVuexStore<IState>({
    state: {} as IState,
    mutations: {},
    actions: {},
    getters: {},
    modules: {
      Messages,
      Users,
      Documents,
      Account,
      Notifications,
      Downloads,
      Companies
    },
  })
}

export const store: AppStore = createStore()

export default store
